<div class="nps">

  <div class="nps__header">
    @if (isUserAtLeastTrainer()) {
      <h2 class="nps__title">{{ 'nps.teacher_would_you_recommend' | translate }}</h2>
    } @else {
      <h2 class="nps__title">{{ 'nps.learner_would_you_recommend' | translate }}</h2>
    }
  </div>

  <div class="nps__content">
    <form id="nps-form"
      class="nps__form"
      [formGroup]="npsForm">
      <mat-radio-group class="nps__radio-group"
        formControlName="value"
        [(ngModel)]="selectedValue">
        <!-- First subgroup of radio buttons (from 0 through 5) -->
        <div class="nps__radio-subgroup">
          @for (number of values | slice:0:6; track number) {
            <mat-radio-button
              class="nps__radio-button"
              [class.nps__radio-button--checked]="selectedValue === number"
              [value]="number">
              <span class="nps__radio-button-number-label">{{ number }}</span>
              <!-- If no radio button is checked OR if first radio button (0) is checked -->
              @if (selectedValue === undefined || selectedValue === number) {
                @if (number === 0) {
                  <span
                    class="nps__radio-button-text-label"
                    [@fadeInAndOut]>
                    {{ "nps.absolutely_not" | translate }}
                  </span>
                }
              }
              <!-- If one radio button from 1 through 5 is checked -->
              @if (selectedValue === number) {
                @if (number >= 1 && number <= 3) {
                  <span
                    class="nps__radio-button-text-label"
                    [@fadeInAndOut]>
                    {{ "nps.absolutely_not" | translate }}
                  </span>
                }
                @if (number >= 4 && number <= 5) {
                  <span
                    class="nps__radio-button-text-label"
                    [@fadeInAndOut]>
                    {{ "nps.i_dont_think_so" | translate }}
                  </span>
                }
              }
            </mat-radio-button>
          }
        </div>
        <!-- Second subgroup of radio buttons (from 6 through 10) -->
        <div class="nps__radio-subgroup">
          @for (number of values | slice:6:11; track number) {
            <mat-radio-button
              class="nps__radio-button"
              [class.nps__radio-button--checked]="selectedValue === number"
              [value]="number">
              <span class="nps__radio-button-number-label">{{ number }}</span>
              <!-- If one radio button from 6 through 9 is checked -->
              @if (selectedValue === number) {
                @if (number === 6) {
                  <span
                    class="nps__radio-button-text-label"
                    [@fadeInAndOut]>
                    {{ "nps.i_dont_think_so" | translate }}
                  </span>
                }
                @if (number >= 7 && number <= 8) {
                  <span
                    class="nps__radio-button-text-label"
                    [@fadeInAndOut]>
                    {{ "nps.maybe" | translate }}
                  </span>
                }
                @if (number === 9) {
                  <span
                    class="nps__radio-button-text-label"
                    [@fadeInAndOut]>
                    {{ "nps.absolutely" | translate }}
                  </span>
                }
              }
              <!-- If no radio button is checked OR if last radio button (10) is checked -->
              @if (selectedValue === undefined || selectedValue === number) {
                @if (number === 10) {
                  <span
                    class="nps__radio-button-text-label"
                    [@fadeInAndOut]>
                    {{ "nps.absolutely" | translate }}
                  </span>
                }
              }
            </mat-radio-button>
          }
        </div>
      </mat-radio-group>
    </form>
  </div>

  <div class="nps__footer">
    <button class="nps__skip-button"
      data-e2e="nps-skip"
      (click)="notNowAction()">
      {{ "generic.not_now" | translate }}
    </button>
    <button class="nps__validate-button"
      data-e2e="nps-validate"
      form="nps-form"
      type="submit"
      [disabled]="!npsForm.valid"
      (click)="SaveNPS()">
      {{'generic.validate' | translate}}
    </button>
  </div>

</div>
